import { steps } from "../data/siteData";

export default function ProcessSection() {
  return (
    <section id="process" className="section" aria-labelledby="process-title">
      <div className="section-heading">
        <p className="eyebrow">How it works</p>
        <h2 id="process-title">
          A clear path from your current level to your next level.
        </h2>
      </div>

      <div className="process-grid">
        {steps.map((step, index) => (
          <article key={step.title} className="process-card">
            <span className="card-number">{String(index + 1).padStart(2, "0")}</span>
            <h3>{step.title}</h3>
            <p>{step.text}</p>
            {step.note ? (
              <span className="process-note">
                <span aria-hidden="true">💡</span>
                <em>{step.note}</em>
              </span>
            ) : null}
          </article>
        ))}
      </div>
    </section>
  );
}
